// extracted by mini-css-extract-plugin
export default {"containerVerticalStepper":"view-activities-styles_containerVerticalStepper__GaxJN","verticalStepperSxElement":"view-activities-styles_verticalStepperSxElement__Gio0d"};